/**
 * Outer audience gate for the Activity / Firefly dock shell.
 * Sections apply their own narrower `roleGate` on top of this floor.
 *
 * WF-0 (firefly_role_context_presentation.md §6.1): `manufacturing`
 * included so mfg-bucket registry entries are reachable for pilots.
 */
export const DOCK_AUDIENCE_ROLES = [
  "sales",
  "sales_rep",
  "ops_reviewer",
  "logistics_coordinator",
  "trainer",
  "marketing",
  "admin",
  "owner",
  "dev",
  "manufacturing",
  "mfg_qc",
  "mfg_final_qc",
  "ads_guidance_editor",
  "org_admin",
  "org_owner",
  "platform_admin",
  "platform_dev",
  "platform_owner",
  "platform_trainer",
] as const;
